import { ApiDef_ShortUrl, DBDef_ShortUrl } from '@nu-art/ts-short-url-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { apiWithQuery, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_onShortUrlsUpdated = new ThunderDispatcherV3('__onShortUrlsUpdated');
export class ModuleFE_ShortUrl_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_ShortUrl, dispatch_onShortUrlsUpdated);
        this._v1 = {
            getShortUrl: apiWithQuery(ApiDef_ShortUrl._v1.getShortUrl)
        };
    }
}
export const ModuleFE_ShortUrl = new ModuleFE_ShortUrl_Class();
//# sourceMappingURL=ModuleFE_ShortUrl.js.map